module.exports = __webpack_public_path__ + "img/9.bda02c28.jpg";